// RenderFieldsDropdown.jsx

import React from 'react';

const RenderFieldsDropdown = ({
  fields,
  formData,
  handleChange,
  readOnly = false,
  validationErrors = {},
}) => {
  return (
    <>
      {fields.map((field) => {
        const fieldValue = formData[field.key] || '';
        const isFieldReadOnly = readOnly || field.readOnly;

        return (
          <div key={field.key} className="flex items-center w-full mb-4">
            {/* Label */}
            <div style={{ width: '200px' }}>
              <label className="font-semibold">{field.label}</label>
            </div>

            {/* Dotted Line */}
            <div style={{ width: '100px', margin: '0 10px' }}>
              <span className="block border-dotted border-b-4 border-gray-200 w-full"></span>
            </div>

            {/* Dropdown */}
            <div style={{ flexGrow: 1 }}>
              <select
                name={field.key}
                className={`border ${
                  validationErrors[field.key]
                    ? 'border-red-500'
                    : 'border-gray-300'
                } p-2 rounded-md w-full`}
                value={fieldValue}
                onChange={handleChange}
                disabled={isFieldReadOnly}
                style={{
                  backgroundColor: isFieldReadOnly ? '#f3f4f6' : 'white',
                }}
              >
                <option value="">Select {field.label}</option>
                {field.options.map((option) => (
                  <option key={option.key} value={option.key}>
                    {option.value}
                  </option>
                ))}
              </select>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default RenderFieldsDropdown;
